import {
  Beneficiary,
  PrescriptionFrequency,
  LowIncomeSubsidyStatus,
  Gender,
} from "../@types";

const bene: Beneficiary = {
  request_id: "007E5EE1-6596D12F-58278701-D6391DC8",
  firstname: ["Jane", "X"],
  lastname: "Doe",
  birthdate: "2014-06-01",
  part_a_start: "2015-10-10",
  part_b_start: "2016-11-11",
  activity_id: "987",
  csr_id: "678",
  lis_level: LowIncomeSubsidyStatus.LIS_LEVEL_2,
  future_lis_level: LowIncomeSubsidyStatus.LIS_LEVEL_4_50,
  current_coverage: [
    {
      contract_id: "H1225",
      plan_id: "002",
      segment_id: "0",
      coverage_year: "2019",
      name: "A Spiffy Plan",
      enrollment_effective_date: "9/5/2020",
      contract_effective_date: "9/5/2020",
      disenrollment_date: "9/5/2020",
    },
  ],
  future_coverage: [],
  future_lis_status_start_date: "2021-10-16",
  pdes: [
    {
      pde_status: "",
      drug: {
        rxcui: "1234",
        ndc: "12345",
        name: "Amoxicillin - AMOXICILLIN",
        strength: "500",
        strength_units: "mg",
        quantity: "30",
        package_type: "PACKAGE_TYPE_BOTTLE",
        package_size: "1",
        package_units: "30",
        form: "DRUG_FORM_CAPSULE",
        frequency: PrescriptionFrequency.DAYS_30,
        is_generic: true,
        package_quantity: "2",
        use_package_quantity: true,
      },
      service_date: "2020-03-01",
    },
    {
      pde_status: "",
      drug: {
        rxcui: "2345",
        ndc: "23456",
        name: "Ibuprofen - IBUPROFEN",
        quantity: "60",
        package_type: "PACKAGE_TYPE_BLISTER",
        package_size: "1",
        package_units: "60",
        strength: "200",
        strength_units: "mg",
        form: "DRUG_FORM_TABLET",
        frequency: PrescriptionFrequency.DAYS_30,
        is_generic: true,
        package_quantity: "2",
        use_package_quantity: false,
      },
      service_date: "2020-10-01",
    },
    {
      pde_status: "",
      drug: {
        rxcui: "3456",
        ndc: "34567",
        name: "Wonder Drug",
        quantity: "60",
        package_type: "PACKAGE_TYPE_BLISTER",
        package_size: "1",
        package_units: "60",
        strength: "200",
        strength_units: "mg",
        form: "DRUG_FORM_TABLET",
        frequency: PrescriptionFrequency.DAYS_30,
        is_generic: true,
        package_quantity: "2",
        use_package_quantity: false,
      },
      service_date: "2014-10-01",
    },
  ],
  plans: ["99999-999"],
  mbi: "23456789",
  hicn: "HICN",
  mailing_address: {
    address_1: "28 BIMINI",
    address_2: "APT 3211",
    address_3: "",
    city: "SUGAR LAND",
    county: "530",
    state: "TX",
    zipcode: "774784610",
  },
  gender: Gender.UNKNOWN,
  ssn: "701512806",
};

export default bene;
